import logo from "./logo.svg";
import "./App.css";
import GridSection from "./gridSection/gridSection";
import GridSection2 from "./gridSection2/gridSection2";
import { useEffect, useRef, useLayoutEffect } from "react";
import BigVideoLayout from "./bigVideoLayout/bigVideoLayout";
import parallax from "./parallax";
import HorseRaceLayout from "./horseRaceLayout/horseRaceLayout";
import Header from "./header/header";
import Scrollbar from "smooth-scrollbar";
import smoothBar from "./smoothBar";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import Id from "./id/id";
import Zoom from "./zoom/zoom";
import VerticallyAndHorizontally from "./verticallyAndHorizontally/verticallyAndHorizontally";
import Smart from "./smart/smart";
import ZyCami from "./zyCami/zyCami";
import LightAndLong from "./lightAndLong/lightAndLong";
import SVGGradientsEditor from "./SVGGradientsEditor/SVGGradientsEditor";
import Battery from "./battery/battery";
import Visualization from "./visualization/visualization";
import Stable from "./stable/stable";
import { useState } from "react";
import DOMPurify from "dompurify";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
// ScrollTrigger.normalizeScroll(true);
let json = {
  text1: "开拍即大片",
  text2: "观看视频",
  text3: "全新设计，倾心使然。",
  text4:
    "采用人体工学设计，将云台控制精准划分，{手指轻松点按就能完成全部操控。}",
  text5:
    "优化握持空间，精准裁切半包硅胶贴面，边角均采用圆滑过渡处理，保证{手感温润饱满。}",
  text6: "云台增稳技术。",
  text7: "使用智云第九代增稳技术，{手机也能带来影视级的稳定拍摄体验。}",
  text8: "手机拍摄",
  text9: "SMOOTH-Q4 拍摄",
  text10: "天生磁吸，_自有光芒。",
  text11:
    "手机夹延续一体磁吸触点设计，{支持两面磁吸安装}使用补光灯，即装即用。支持{5500K标准色温}，{4档位亮度调节}补光，可满足不同暗光场景拍摄需求。",
  text12: "* 此功能需搭配磁吸补光灯使用，0.6m实验室环境下照度为141lux。",
  text13: "215mm延长杆，_能拍尽拍。",
  text14:
    "可在 {215 毫米延长杆范围内}随意自拍和获取不同拍摄角度，{想拍什么角度，都能尽情畅拍。}",
  text15: "一步收纳，_轻巧握持。",
  text16:
    "无需整理云台就能折叠和展开拍摄，一步到位，自带收纳卡扣，{折叠后依旧轻巧可以放进口袋。}",
  text17: "双控式拨轮。",
  text18:
    "侧面波轮集成变焦和控光系统，既能{点按调节补光灯亮度}，也可{上下滑动控制拍摄焦距。}",
  text19: "可视化状态，_一目清晰。",
  text20:
    "{可视化模式和云台状态指示清晰明了}，按键和控制摇杆布局更符合创作习惯。多种创意运镜和拍摄模式，三维梦境旋转效果和快速转场，大师手法也能信手拈来。",
  text21: "横竖之间，_皆是创意。",
  text22:
    "{瞬间切换手机横屏和竖屏拍摄姿态}，横屏写意，竖屏人景，直播和短视频拍摄使用一键到位。",
  text23: "智能场景，_指引拍摄。",
  text24:
    "在录像模式下可{智能识别当前场景 }，根据视频场景匹配拍摄样片指引教学，{亦可手动选择}想要的拍摄场景，推荐适合的拍摄手法，轻松出大片。",
  text25: "手势_智能控制。",
  text26: "全景_魔法分身。",
  text27: "智拍生活，自在玩法。",
  text28: "SMART模板",
  text29: "智能希区柯克",
  text30: "智能跟踪",
  text31: "全景魔法分身",
  text32: "手势智能控制",
  text33: "ZY Cami 编辑器",
  text34: "直播“大师”",
  text35: "云剪辑，一键模板",
  text36: "查看软件详情",
  text37: "长续航电池。",
  text38: "内置1200mAh电池，展示模式下{续航时间最长达10h。}",
  text39:
    "* 该数据是在环境温度为25度时，装载 iPhone XR（220g） , 将云台重心调整平衡，展示模式时测试的运行时间。",
  text40: "* 调节补光灯亮度功能需搭配磁吸补光灯使用。",
};

let language = document.querySelector('meta[name="language"]').content;
document.getElementById("root").setAttribute("lang", language);

let footer = document.querySelector('.zhiyun-footer-new');
let oldFooter = document.querySelector('footer');
if(oldFooter){
  footer.append(oldFooter)
}else{
  oldFooter = document.querySelector('#footer');
  footer.append(oldFooter)
}


function is_weixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

let isWeiXin = is_weixin();

function App() {
  const [textData, setTextData] = useState(json);
  const smoother = useRef(null);

  useEffect(() => {
    async function fetchData() {
      let response = await fetch(
        `https://www.zhiyun-tech.com/website/in18/smq4/${language}.json`
      );
      if (response.ok) {
        let json = await response.json();
        function formatText(text) {
          if (text.indexOf("{") < 0 && text.indexOf("_") < 0) {
            return text;
          } else if (text.indexOf("{") >= 0) {
            let rightBrackets = text.indexOf("{");
            let leftBrackets = text.indexOf("}") + 1;
            let oldText = text.slice(rightBrackets, leftBrackets);
            let newText = `<div class="mainText">${text.slice(
              rightBrackets + 1,
              leftBrackets - 1
            )}</div>`;

            return formatText(text.replace(oldText, newText));
          } else if (text.indexOf("_") >= 0) {
            let brackets = text.indexOf("_");
            let oldText = text.slice(brackets, brackets + 1);
            let newText = `<br />`;
            return formatText(text.replace(oldText, newText));
          }
        }

        for (let item in json) {
          json[item] = formatText(json[item]);
        }
        setTextData(json);
      } else {
        console.log("HTTP-Error: " + response.status);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    // create the scrollSmoother before your scrollTriggers

    ScrollTrigger.matchMedia({
      // large
      "(min-width: 1025px)": function () {
        smoother.current = ScrollSmoother.create({
          content: "#smooth-content",
          smooth: 0.6, // how long (in seconds) it takes to "catch up" to the native scroll position
          effects: true, // looks for data-speed and data-lag attributes on elements
          smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
          // onUpdate: (self) => {
          //   if(self.progress === 1) {
          //     console.log(self)
          //     ScrollTrigger.refresh();
          //   }
          // },
        });
      },

      // medium
      "(min-width: 600px) and (max-width: 959px)": function () {
        // The ScrollTriggers created inside these functions are segregated and get
        // reverted/killed when the media query doesn't match anymore.
      },

      // small
      "(max-width: 1024px)": function () {
        // The ScrollTriggers created inside these functions are segregated and get
        // reverted/killed when the media query doesn't match anymore.
        // if(smoother.current){
        //   smoother.current.kill()
        // }
      },

      // all
      all: function () {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });
  }, []);
  useEffect(() => {
    document
      .querySelectorAll("div[data-parallax=true] > img")
      .forEach((item) => {
        parallax(
          {
            trigger: item,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
          item,
          "%"
        );
      });
  }, []);

  const setImgLoadComplate = () => {
    ScrollTrigger.refresh();
  };

  return (
    <div className="App">
      <div style={{ width: "100%", backgroundColor: "#000" }}>
        <Header textData={textData} language={language} isWeiXin={isWeiXin} />
        <Id
          setImgLoadComplate={setImgLoadComplate}
          language={language}
          textData={textData}
        />
        <Stable
          setImgLoadComplate={setImgLoadComplate}
          language={language}
          textData={textData}
        />
        <LightAndLong textData={textData} language={language} />
      </div>

      <Zoom textData={textData} language={language} />
      <Visualization textData={textData} language={language} />
      <VerticallyAndHorizontally textData={textData} language={language} />
      <Smart textData={textData} language={language} />
      {/* <GridSection />

        <LightAndLong />
        <BigVideoLayout
          title="任意角度，<br />想拍就拍。"
          src="https://bucket.zhiyun-tech.com/detail/m2s/M2S.mp4"
        />
        */}
      {/* <GridSection2 />  */}
      <BigVideoLayout
        title={textData["text25"]}
        poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-13-poster${
          language === "cn" ? "" : "-en"
        }.jpg`}
        src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-13${
          language === "cn" ? "" : "-en"
        }.mp4`}
        setImgLoadComplate={setImgLoadComplate}
        language={language}
      />
      <BigVideoLayout
        title={textData["text26"]}
        poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-14-poster${
          language === "cn" ? "" : "-en"
        }.jpg`}
        src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-14${
          language === "cn" ? "" : "-en"
        }.mp4`}
        textAlign="right"
        setImgLoadComplate={setImgLoadComplate}
        language={language}
      />
      {/* <HorseRaceLayout /> */}
      <ZyCami textData={textData} language={language} />

      {/* <Battery textData={textData} />  */}
    </div>
  );
}

export default App;
